import axios from "axios";

export const getUserInfo = (email: string): any => {
  return axios.get("/user/v1/email/" + email);
};

export const getAllReadyOpGroups = (): any => {
  return axios.get("/system/notifications/groups");
};


export const getUserNotificationPreferences = (email: string): any => {
  return axios.get("/user/v1/email/" + email + "/notification-preferences");
};


export const updateUserReadyOpGroups = (email: string, groupIds: string[]): any => {
  return axios.put("/user/v1/email/" + email + "/notification/group", { groupIds });
};


export const updateUserNotificationPreferences = (email: string, groupIds: string[], isTextable: Boolean): any => {
  return axios.put("/user/v1/email/" + email + "/notification-preferences", { groupIds, isTextable });
};


export const updateUserProfile = (
  cognitoUsername: string,
  givenName: string,
  familyName: string,
  phoneNumber: string,
): any => {
  return axios.put("/user/v1/" + cognitoUsername + "/profile", {
    cognitoUsername: cognitoUsername,
    givenname: givenName,
    familyname: familyName,
    phonenumber: phoneNumber,
  });
};

export const getUserPreferences = (email: string): any => {
  return axios.get("/user/v1/email/" + email + "/Preferences");
};

export const updateUserPreferences = (
  email: string,
  isMapCenter: boolean,
  isLeftPanelCollapsed: boolean,
  isRightPanelCollapsed: boolean,
  agencyFilters: string[],
  jogFilters: string[],
  mapLayers: string[],
  markerLayers: string[],
  timeFrame: number,
  feedView: string,
  showOpenDispatchesOnly: boolean,
  jogNotificationsPostConf?: string[], // Only for use during invite user.
): any => {
  return axios.put("/user/v1/email/" + email + "/Preferences", {
    isMapCenter,
    isLeftPanelCollapsed,
    isRightPanelCollapsed,
    agencyFilters,
    jogFilters,
    mapLayers,
    markerLayers,
    timeFrame,
    feedView,
    showOpenDispatchesOnly,
    ...(jogNotificationsPostConf && { jogNotificationsPostConf }), // Conditionally add.
  });
};